import { Coffee, GraduationCap, Heartbeat, ShoppingBag, Barbell, Scissors, Buildings, ForkKnife } from "@phosphor-icons/react";
import { LOGO_URL } from "./Navbar";

// Order matters: starts at top (12 o'clock) and goes clockwise (matches reference)
const NODES = [
  { icon: Coffee, label: "Food & Beverages" },
  { icon: GraduationCap, label: "Education" },
  { icon: Heartbeat, label: "Healthcare" },
  { icon: ShoppingBag, label: "Retail" },
  { icon: Barbell, label: "Fitness & Wellness" },
  { icon: Scissors, label: "Beauty & Salon" },
  { icon: Buildings, label: "Real Estate" },
  { icon: ForkKnife, label: "Restaurants" },
];

export function EcosystemOrbit({ count = 8 }) {
  const nodes = NODES.slice(0, count);
  const radius = 40; // % from center where node sits

  return (
    <div data-testid="ecosystem-orbit" className="relative w-full max-w-[500px] aspect-square mx-auto"
      style={{ background: "radial-gradient(circle, rgba(212,175,55,0.06) 0%, transparent 62%)" }}>
      {/* center glow */}
      <div className="absolute inset-[30%] rounded-full bg-gold/20 blur-3xl" />

      {/* concentric orbit rings — dark with a subtle gold shine */}
      <div className="absolute inset-[10%] rounded-full border border-gold/25 shadow-[inset_0_0_40px_-20px_rgba(212,175,55,0.4)]" />
      <div className="absolute inset-[22%] rounded-full border border-gold/15" />
      <div className="absolute inset-[33%] rounded-full border border-gold/12" />
      <div className="absolute inset-[42%] rounded-full border border-gold/10" />

      {/* center logo */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
        <div className="relative grid place-items-center w-20 h-20 md:w-28 md:h-28">
          <div className="absolute inset-0 rounded-full bg-gold/20 blur-2xl" />
          <img src={LOGO_URL} alt="EBG FinCorp" className="relative w-full h-full object-contain" />
        </div>
      </div>

      {/* nodes + always-visible labels */}
      {nodes.map((n, i) => {
        const angle = (i / nodes.length) * 2 * Math.PI - Math.PI / 2;
        const x = 50 + radius * Math.cos(angle);
        const y = 50 + radius * Math.sin(angle);
        const Icon = n.icon;
        return (
          <div key={n.label} className="absolute -translate-x-1/2 -translate-y-1/2 group flex flex-col items-center" style={{ left: `${x}%`, top: `${y}%` }}>
            <div className="grid place-items-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-navy-950 border border-gold/40 transition-all duration-300 group-hover:border-gold group-hover:scale-110"
              style={{ boxShadow: "0 0 24px -8px rgba(212,175,55,0.45), inset 0 1px 1px rgba(255,255,255,0.10)" }}>
              <Icon size={26} className="text-gold" weight="light" />
            </div>
            <span className="absolute top-full mt-2 whitespace-nowrap text-[10px] md:text-xs font-normal text-white/90">{n.label}</span>
          </div>
        );
      })}
    </div>
  );
}
